<ion-app id="ionApp" class="qrEnableds">
  <ion-router-outlet> </ion-router-outlet>
  <div class="qrOverlay">
    <!-- add flex row with 3 buttons in using tailwind as rounded btns -->
    <ng-container *ngIf="cameraZoomData$ | async as cameraZoomData">
      <ng-container *ngIf="cameraZoomData.currentZoomRatio !== undefined">
        <!-- <p>
        {{ cameraZoomData.currentZoomRatio }} - {{ cameraZoomData.minZoom.zoomRatio }} - {{ cameraZoomData.maxZoom.zoomRatio }}
      </p> -->
        <div class="flex flex-row justify-center items-center gap-8">
          <button
            class="rounded-full bg-blue p-2 text-white text-lg w-12 h-12 flex justify-center items-center"
            (click)="zoom('out')"
            [ngClass]="cameraZoomData.minZoom.zoomRatio === cameraZoomData.currentZoomRatio ? 'opacity-30' : ''"
          >
            <fa-icon [icon]="['far', 'magnifying-glass-minus']"></fa-icon>
          </button>
          <button class="rounded-full bg-red p-2 text-white text-lg w-16 h-16 flex justify-center items-center" (click)="closeQrCode()">
            <fa-icon [icon]="['far', 'xmark']"></fa-icon>
          </button>
          <button
            class="rounded-full bg-blue p-2 text-white text-lg w-12 h-12 flex justify-center items-center"
            (click)="zoom('in')"
            [ngClass]="cameraZoomData.maxZoom.zoomRatio === cameraZoomData.currentZoomRatio ? 'opacity-30' : ''"
          >
            <fa-icon [icon]="['far', 'magnifying-glass-plus']"></fa-icon>
          </button>
        </div>
      </ng-container>
    </ng-container>
  </div>

  <div id="cameraPreview" class="hidden flex-1 flex-col p-4 justify-between">
    <div id="videoContainer"></div>
    <div class="flex justify-between items-center buttons">
      <div>
        <button
          class="rounded-full bg-red border-solid border-2 border-white h-12 w-12 flex justify-center items-center text-white text-base"
          (click)="cameraPreviewCancel()"
        >
          <fa-icon [icon]="['far', 'x']"></fa-icon>
        </button>
      </div>
      <button
        class="rounded-full bg-gold border-solid border-4 border-white h-[4.5rem] w-[4.5rem] flex justify-center items-center text-white text-2xl"
        (click)="cameraCapture()"
      >
        <fa-icon [icon]="['fal', 'camera']"></fa-icon>
      </button>
      <div>
        <button
          class="relative rounded-full bg-blue border-solid border-2 border-white h-12 w-12 flex justify-center items-center text-white text-base"
          (click)="cameraPreviewComplete()"
        >
          <fa-icon [icon]="['far', 'check']"></fa-icon>
          <ng-container *ngIf="capturedPhotos$ | async as capturedPhotos">
            <div
              *ngIf="capturedPhotos.length > 0"
              class="absolute -top-2 -right-2 pointer-events-none bg-gold rounded-full w-6 h-6 flex items-center justify-center text-white text-xs font-bold"
            >
              {{ capturedPhotos.length }}
            </div>
          </ng-container>
        </button>
      </div>
    </div>
  </div>
  <app-root-galleria></app-root-galleria>
  <div #modalwrapper class="modal-wrapper"></div>
</ion-app>
<p-toast key="loading"></p-toast>
<!-- baseZIndex keeps toasts above Ionic modals (e.g. the MFA code screen) -->
<p-toast [baseZIndex]="30000"></p-toast>
<p-confirmDialog></p-confirmDialog>
